import { Link } from "react-router-dom";
import { useSetAtom } from "jotai";
import { Icon } from "@common/index";
import { ROUTES } from "@routing/routes";
import { useCanShop } from "@/hooks/useCanShop";
import { isMobileDrawerOpenAtom } from "./CustomerNavigation/store/drawerAtoms";
import { isSearchPanelOpenAtom } from "@customer/Search/store/searchAtoms";

export const Footer = () => {
    const setDrawerOpen = useSetAtom(isMobileDrawerOpenAtom);
    const openSearchPanel = useSetAtom(isSearchPanelOpenAtom);

    // Same gate as MobileNav: only a shopper who can shop gets a Search entry
    // point. The panel it opens reads GET /categories, which the API walls to
    // active customers (#416), and this footer renders on the public pages too.
    const canShop = useCanShop();

    return (
        <>
            <footer
                data-testid="desktop-footer"
                className="bg-secondary text-secondary-content"
            >
                <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col items-center gap-3">
                    <div className="flex items-center gap-6">
                        <img
                            src="/logo/Mark-Gold.svg"
                            alt="NARA"
                            className="h-6 w-auto"
                        />
                        <Link
                            to={ROUTES.ABOUT}
                            className="font-bold hover:underline"
                        >
                            About
                        </Link>
                        <Link
                            to={ROUTES.SUPPORT}
                            className="font-bold hover:underline"
                        >
                            Support
                        </Link>
                    </div>
                    <div className="text-sm text-secondary-content/80">
                        © {new Date().getFullYear()} NARA. All Rights Reserved.{" "}
                        <Link
                            to={ROUTES.TERMS}
                            className="underline hover:no-underline"
                        >
                            Terms and Conditions
                        </Link>
                        {" | "}
                        <Link
                            to={ROUTES.PRIVACY}
                            className="underline hover:no-underline"
                        >
                            Privacy Policy
                        </Link>
                    </div>
                </div>
            </footer>

            {/* Kept hidden; reserved for a future mobile surface. */}
            <nav
                data-testid="mobile-tab-bar"
                aria-label="Mobile navigation"
                className="hidden fixed bottom-0 inset-x-0 z-40 bg-secondary text-secondary-content shadow-[0_-2px_8px_rgba(0,0,0,0.15)]"
            >
                {/* One equal column per rendered tab, however many the gates leave. */}
                <div
                    data-testid="mobile-tab-bar-grid"
                    className="grid grid-flow-col auto-cols-fr h-14"
                >
                    <Link
                        to={ROUTES.BROWSE}
                        aria-label="Home"
                        className="flex items-center justify-center btn btn-ghost btn-square h-full rounded-none"
                    >
                        <Icon name="home" className="text-2xl" />
                    </Link>
                    {canShop && (
                        <button
                            type="button"
                            aria-label="Search"
                            onClick={() => openSearchPanel(true)}
                            className="flex items-center justify-center btn btn-ghost btn-square h-full rounded-none"
                        >
                            <Icon name="search" className="text-2xl" />
                        </button>
                    )}
                    <Link
                        to={ROUTES.CART}
                        aria-label="Cart"
                        className="flex items-center justify-center btn btn-ghost btn-square h-full rounded-none"
                    >
                        <Icon name="shopping_cart" className="text-2xl" />
                    </Link>
                    <button
                        type="button"
                        aria-label="Open menu"
                        onClick={() => setDrawerOpen(true)}
                        className="flex items-center justify-center btn btn-ghost btn-square h-full rounded-none"
                    >
                        <Icon name="menu" className="text-2xl" />
                    </button>
                </div>
            </nav>
        </>
    );
};
